import React, { useEffect, useState } from "react";
import "./index.css";
import { Link, useLocation } from "react-router-dom";
import {
  LayoutDashboard,
  Lightbulb,
  ShoppingCart,
  Store,
  Receipt,
  BarChart3,
  LineChart,
  RefreshCw,
  FileText,
  FolderOpen,
  Bell,
  User,
  LogOut,
} from "lucide-react";
import { useAuth } from "context/auth/auth";
import { PortalService } from "services/portal";
import logo from "../../assets/white.png";

const NAV_SECTIONS = [
  {
    title: "Inicio",
    items: [
      { label: "Dashboard", path: "/portal/dashboard", icon: LayoutDashboard },
      { label: "Recomendaciones", path: "/portal/recomendaciones", icon: Lightbulb },
    ],
  },
  {
    title: "Mis registros",
    items: [
      { label: "Compras", path: "/portal/compras", icon: ShoppingCart },
      { label: "Ventas", path: "/portal/ventas", icon: Store },
      { label: "Gastos", path: "/portal/gastos", icon: Receipt },
    ],
  },
  {
    title: "Análisis",
    items: [
      { label: "Consolidado anual", path: "/portal/consolidado-anual", icon: BarChart3 },
      { label: "Histórico", path: "/portal/consolidado-historico", icon: LineChart },
    ],
  },
  {
    title: "SII",
    items: [
      { label: "Sincronizaciones", path: "/portal/sincronizaciones", icon: RefreshCw },
      { label: "Facturas (PDF)", path: "/portal/facturas-pdf", icon: FileText },
    ],
  },
  {
    title: "Cuenta",
    items: [
      { label: "Documentos", path: "/portal/documentos", icon: FolderOpen },
      { label: "Notificaciones", path: "/portal/notificaciones", icon: Bell, badge: true },
      { label: "Mi perfil", path: "/portal/perfil", icon: User },
    ],
  },
];

function NavItem({ label, path, Icon, badgeCount }) {
  const location = useLocation();
  const isActive = location.pathname === path;

  return (
    <Link to={path} className="portal-sidebar-link">
      <div className={`portal-sidebar-item${isActive ? " active" : ""}`}>
        <Icon size={16} strokeWidth={isActive ? 2.4 : 2} className="portal-sidebar-icon" />
        <span>{label}</span>
        {badgeCount > 0 && (
          <span className="portal-sidebar-badge">
            {badgeCount > 99 ? "99+" : badgeCount}
          </span>
        )}
      </div>
    </Link>
  );
}

export default function PortalSidebar() {
  const auth = useAuth();
  const fullName = auth.portalUser?.name || "";
  const firstName = fullName.split(" ")[0] || "";
  const initials = fullName
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((s) => s.charAt(0).toUpperCase())
    .join("") || "?";
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    if (auth.portalToken) {
      PortalService.getUnreadCount()
        .then((res) => setUnreadCount(res.count || 0))
        .catch(() => {});
    }
  }, [auth.portalToken]);

  return (
    <nav className="portal-sidebar-nav">
      {/* Logo */}
      <div className="portal-sidebar-logo">
        <img src={logo} alt="Profit" />
      </div>

      {/* User card */}
      <div className="portal-sidebar-user">
        <div className="portal-sidebar-avatar">
          <span>{initials}</span>
        </div>
        <div className="portal-sidebar-user-meta">
          <div className="portal-sidebar-user-name">
            {firstName || "Cliente"}
          </div>
          <div className="portal-sidebar-user-tag">
            <span className="portal-sidebar-dot" /> Portal de Clientes
          </div>
        </div>
      </div>

      {/* Nav sections */}
      <div className="portal-sidebar-sections">
        {NAV_SECTIONS.map((section) => (
          <div key={section.title} className="portal-sidebar-section">
            <div className="portal-sidebar-section-title">{section.title}</div>
            {section.items.map((item) => (
              <NavItem
                key={item.path}
                label={item.label}
                path={item.path}
                Icon={item.icon}
                badgeCount={item.badge ? unreadCount : 0}
              />
            ))}
          </div>
        ))}
      </div>

      {/* Logout */}
      <div className="portal-sidebar-footer">
        <button
          className="portal-sidebar-logout"
          onClick={() => auth.revokeAuth({ isPortal: true })}
        >
          <LogOut size={16} strokeWidth={2} className="portal-sidebar-icon" />
          <span>Cerrar sesión</span>
        </button>
      </div>
    </nav>
  );
}
